<div class="flex row gap-10">
  <div class="company-contacts-container">
    <div class="company-first-contact-container">
      @if (contacts()?.length > 0) {
        <ng-container
          content
          [ngTemplateOutlet]="contactTemplate"
          [ngTemplateOutletContext]="{
            contact: contacts()[0],
            firstContact: true
          }"
        ></ng-container>
      }
      @if (contacts()?.length > 1) {
        @if (!displayOthersOnClick() || (displayOthersOnClick() && !displayOthers())) {
          <span
            class="other-contacts-name"
            [class.cursor]="displayOthersOnClick()"
            [tiimeTooltip]="contacts() | map: mapToOtherContacts"
            [tooltipDisabled]="displayOthersOnClick()"
            (click)="displayOthersOnClick() ? toggleOthers() : null"
          >
            +{{ contacts().length - 1 }}
          </span>
        }
      }
    </div>
    @if (displayOthers()) {
      <div class="company-other-contacts-container">
        @for (contact of contacts().slice(1); track contact.id) {
          <ng-container
            content
            [ngTemplateOutlet]="contactTemplate"
            [ngTemplateOutletContext]="{
              contact
            }"
          ></ng-container>
        }
      </div>
    }
  </div>
  @if (displayOthers()) {
    <button tiime-button color="primary" icon (click)="toggleOthers()">
      <mat-icon fontSet="fontastic" fontIcon="icon-ic-error-rounded"></mat-icon>
    </button>
  }
</div>

<ng-template #contactTemplate let-contact="contact" let-firstContact="firstContact">
  <div class="contact-value-container" [class.first-contact-name]="firstContact">
    @if (showPrefix()) {
      <span class="contact-value-prefix">{{ contact | map: mapToContactPrefix }}</span>
    }
    <span class="contact-value" [tiimeTooltip]="contact | map: mapToContactTooltip">
      {{ contact | map: mapToContactFullName }}
    </span>
    @if (showSuffix()) {
      <span class="contact-value-suffix">{{ contact | map: mapToContactSuffix }}</span>
    }
  </div>
</ng-template>
